import { __decorate, __metadata } from 'tslib';
import { FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiCToggleModule } from '@wlp/ui-c-toggle';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCAddPartnersEcComponent = class UiCAddPartnersEcComponent {
    constructor() {
        this.save = new EventEmitter();
        this.onChange = new EventEmitter();
        this.eventLegalRepresentative = new EventEmitter();
        this.eventAttorney = new EventEmitter();
        this.eventPartner = new EventEmitter();
        this.legalRepresentative = false;
        this.attorney = false;
        this.partner = false;
        this.offLegalRepresentative = false;
        this.offAttorney = false;
        this.offPartner = false;
    }
    ngOnInit() {
        if (this.readonly === undefined) {
            this.readonly = false;
        }
        this.ionViewDidLoad();
    }
    ionViewDidLoad() {
        this.formAddPartners.get('legalRepresentative').value ? this.legalRepresentative = this.formAddPartners.get('legalRepresentative').value : null;
        this.formAddPartners.get('attorney').value ? this.attorney = this.formAddPartners.get('attorney').value : null;
        this.formAddPartners.get('partner').value ? this.partner = this.formAddPartners.get('partner').value : null;
        if (this.legalRepresentative) {
            this.offAttorney = true;
            this.offPartner = true;
        }
        if (this.attorney) {
            this.offLegalRepresentative = true;
            this.offPartner = true;
        }
        if (this.partner) {
            this.offLegalRepresentative = true;
            this.offAttorney = true;
        }
    }
    ngOnDestroy() {
        this.offLegalRepresentative = null;
        this.offAttorney = null;
        this.offPartner = null;
    }
    onChangeForm() {
        this.onChange.emit(this.formAddPartners);
    }
    saveBtn() {
        this.save.emit();
    }
    formIsValid() {
        if (this.formAddPartners.invalid) {
            return true;
        }
        else {
            if (this.legalRepresentative === true || this.attorney === true || this.partner === true) {
                return false;
            }
            else {
                return true;
            }
        }
    }
    ionChangeLegalRepresentative() {
        if (this.legalRepresentative) {
            this.legalRepresentative = false;
            this.offAttorney = false;
            this.offPartner = false;
        }
        else {
            this.legalRepresentative = true;
            this.attorney = false;
            this.partner = false;
            this.offAttorney = true;
            this.offPartner = true;
        }
    }
    ionChangeAttorney() {
        if (this.attorney) {
            this.attorney = false;
            this.offLegalRepresentative = false;
            this.offPartner = false;
        }
        else {
            this.attorney = true;
            this.legalRepresentative = false;
            this.partner = false;
            this.offLegalRepresentative = true;
            this.offPartner = true;
        }
    }
    ionChangePartner() {
        if (this.partner) {
            this.partner = false;
            this.offAttorney = false;
            this.offLegalRepresentative = false;
        }
        else {
            this.partner = true;
            this.attorney = false;
            this.legalRepresentative = false;
            this.offAttorney = true;
            this.offLegalRepresentative = true;
        }
    }
};
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], UiCAddPartnersEcComponent.prototype, "formAddPartners", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCAddPartnersEcComponent.prototype, "errorMessages", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCAddPartnersEcComponent.prototype, "businessPartner", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCAddPartnersEcComponent.prototype, "readonly", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAddPartnersEcComponent.prototype, "save", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAddPartnersEcComponent.prototype, "onChange", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAddPartnersEcComponent.prototype, "eventLegalRepresentative", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAddPartnersEcComponent.prototype, "eventAttorney", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAddPartnersEcComponent.prototype, "eventPartner", void 0);
UiCAddPartnersEcComponent = __decorate([
    Component({
        selector: 'ui-c-add-partners-ec',
        template: "<div class=\"warning border ion-padding ion-margin\">\n  <ion-row>\n    <ion-col size=\"12\">\n      <form [formGroup]=\"formAddPartners\" (change)=\"onChangeForm()\">\n        <div class=\"details\">\n          <ion-row>\n            <ion-col size=\"12\">\n              <div class=\"detail-item\">\n                <ion-item>\n                  <span class=\"icn-holder\" slot=\"end\" *ngIf=\"!formAddPartners.get('fullname').invalid\">\n                    <ion-icon name=\"checkmark-circle\"> </ion-icon>\n                  </span>\n                  <ion-input (change)=\"$event.target.value = $event.target.value.toUpperCase()\"\n                    formControlName=\"fullname\"\n                    type=\"text\"\n                    class=\"fullname\"\n                    placeholder=\"Nome do S\u00F3cio\"\n                    tooltip=\"O nome n\u00E3o pode conter abrevia\u00E7\u00F5es!\"\n                    placement=\"top\"\n                    show-delay=\"500\"\n                    maxlength=\"100\"\n                    [readonly]=\"readonly\"\n                  >\n                  </ion-input>\n                </ion-item>\n\n                <div class=\"error-messages\">\n                  <ng-container *ngFor=\"let error of errorMessages.fullname\">\n                    <div\n                      class=\"error-message\"\n                      *ngIf=\"\n                        formAddPartners.get('fullname').hasError(error.type) &&\n                        (formAddPartners.get('fullname').invalid || formAddPartners.get('fullname').touched)\n                      \"\n                    >\n                      {{ error.message | wlpTranslate: error?.param }}\n                    </div>\n                  </ng-container>\n                </div>\n              </div>\n            </ion-col>\n          </ion-row>\n\n          <ion-row>\n            <ion-col size=\"12\">\n              <div class=\"detail-item\">\n                <ion-item>\n                  <span class=\"icn-holder\" slot=\"end\" *ngIf=\"!formAddPartners.get('docNumber').invalid\">\n                    <ion-icon name=\"checkmark-circle\"> </ion-icon>\n                  </span>\n                  <ion-input (change)=\"$event.target.value = $event.target.value.toUpperCase()\"\n                    formControlName=\"docNumber\"\n                    mask=\"000.000.000-00\"\n                    class=\"docNumber\"\n                    placeholder=\"N\u00FAmero do CPF\"\n                    type=\"tel\"\n                    [readonly]=\"readonly\"\n                  >\n                  </ion-input>\n                </ion-item>\n\n                <div class=\"error-messages\">\n                  <ng-container *ngFor=\"let error of errorMessages.docNumber\">\n                    <div\n                      class=\"error-message\"\n                      *ngIf=\"\n                        formAddPartners.get('docNumber').hasError(error.type) &&\n                        (formAddPartners.get('docNumber').invalid || formAddPartners.get('docNumber').touched)\n                      \"\n                    >\n                      {{ error.message | wlpTranslate: error?.param }}\n                    </div>\n                  </ng-container>\n                </div>\n              </div>\n            </ion-col>\n          </ion-row>\n        </div>\n\n        <ion-row>\n          <ion-col size=\"12\" class=\"ion-padding\">\n            <ion-item lines=\"none\">\n              <ion-label>{{ 'ONBORDING.ADD_PARTNERS.OPTIONS.OPTION_1' | wlpTranslate }}</ion-label>\n              <ion-toggle\n                slot=\"start\"\n                color=\"success\"\n                formControlName=\"legalRepresentative\"\n                (ionChange)=\"ionChangeLegalRepresentative()\"\n                [disabled]=\"offLegalRepresentative\"\n              ></ion-toggle>\n            </ion-item>\n            <ion-item lines=\"none\">\n              <ion-label>{{ 'ONBORDING.ADD_PARTNERS.OPTIONS.OPTION_2' | wlpTranslate }}</ion-label>\n              <ion-toggle\n                slot=\"start\"\n                color=\"success\"\n                formControlName=\"attorney\"\n                (ionChange)=\"ionChangeAttorney()\"\n                [disabled]=\"offAttorney\"\n              ></ion-toggle>\n            </ion-item>\n            <ion-item lines=\"none\">\n              <ion-label>{{ 'ONBORDING.ADD_PARTNERS.OPTIONS.OPTION_3' | wlpTranslate }}</ion-label>\n              <ion-toggle\n                slot=\"start\"\n                color=\"success\"\n                formControlName=\"partner\"\n                (ionChange)=\"ionChangePartner()\"\n                [disabled]=\"offPartner\"\n              ></ion-toggle>\n            </ion-item>\n          </ion-col>\n        </ion-row>\n        <ui-c-button expand=\"block\" [disabled]=\"formIsValid()\" (continue)=\"saveBtn()\">\n          <span class=\"title\">{{ 'ONBORDING.ADD_PARTNERS.BUTTON_SAVE_PARTNER' | wlpTranslate }}</span>\n        </ui-c-button>\n      </form>\n    </ion-col>\n  </ion-row>\n</div>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCAddPartnersEcComponent);

let UiCAddPartnersEcModule = class UiCAddPartnersEcModule {
};
UiCAddPartnersEcModule = __decorate([
    NgModule({
        declarations: [
            UiCAddPartnersEcComponent
        ],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            FormsModule,
            IonicModule,
            NgxMaskIonicModule,
            UiCToggleModule,
            UiCButtonModule,
            UiBsTranslateModule
        ],
        exports: [
            UiCAddPartnersEcComponent
        ]
    })
], UiCAddPartnersEcModule);

export { UiCAddPartnersEcComponent, UiCAddPartnersEcModule };
//# sourceMappingURL=wlp-ui-c-add-partners-ec.js.map
